interface IPopupPropyAI {
  type: string;
  dismiss: boolean;
}
const dismissedPopupAIRealEstateSummit2023 = (state = false, action: IPopupPropyAI) => {
  switch (action.type) {
      case 'DISMISS_POPUP_AI_REAL_ESTATE_SUMMIT_2023':
          return action.dismiss
      default:
          return state
  }
}

export default dismissedPopupAIRealEstateSummit2023;